var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6168 10.2418C13.6082 8.65385 14.3264 7.45529 15.7803 6.5726C14.9668 5.40865 13.738 4.76827 12.1154 4.64279C10.5793 4.52164 8.90048 5.53846 8.28606 5.53846C7.63702 5.53846 6.14856 4.68606 4.98029 4.68606C2.56587 4.725 0 6.61154 0 10.4495C0 11.5832 0.207692 12.7543 0.623077 13.963C1.17692 15.551 3.17596 19.4452 5.26154 19.3803C6.35192 19.3543 7.12212 18.6058 8.54135 18.6058C9.91731 18.6058 10.6312 19.3803 11.8471 19.3803C13.95 19.35 15.7587 15.8106 16.2865 14.2183C13.4654 12.8899 13.6168 10.324 13.6168 10.2418ZM11.1678 3.13702C12.349 1.7351 12.2409 0.458654 12.2063 0C11.1635 0.0605769 9.95625 0.709615 9.26827 1.5101C8.51106 2.36683 8.06538 3.42692 8.16058 4.62115C9.2899 4.70769 10.3197 4.12788 11.1678 3.13702Z",
    fill: "#DFEC49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleYellow);
export default __webpack_public_path__ + "static/media/apple-yellow.2e60597fa795af85bb59702e2670e2e1.svg";
export { ForwardRef as ReactComponent };